export enum WlrLocationTypeEnum {
  NEW_LINE = "New Line",
  TRANSFER = "Line Transfer",
  BROADBAND_ONLY = "Existing Line (Broadband Only)",
  NEW_FTTP = "New FTTP Provide",
  NEW_SOGEA = "SoGEA Provide",
  EXISTING_SOGEA = "SoGEA FTTC (Broadband Only)",
  WLR_RESIGN = "Resign",
}
